import { Heading, SkeletonBox } from '@circlefin/components'
import { GraphQLErrorBoundary } from '@shared/components/errors'
import { Content } from '@shared/components/layout'
import { useCustomerFxBatchSettlementByJobIdQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import {
  CustomerFxBatchSettlementCard,
  CustomerFxBatchSettlementDetailCard,
} from '../../components'
import { TradesTable } from '../TradesTable'

export interface CustomerFxBatchSettlementDetailProps {
  /**
   * Customer Fx Batch Settlement Job ID.
   */
  jobId: string
}

export const CustomerFxBatchSettlementDetail: React.FC<
  CustomerFxBatchSettlementDetailProps
> = ({ jobId }) => {
  const { t } = useTranslation('payments')

  const { data, loading, error } = useCustomerFxBatchSettlementByJobIdQuery({
    variables: { jobId },
  })

  if (!data?.customerFxBatchSettlementByJobId) {
    return null
  }

  return (
    <Content>
      <GraphQLErrorBoundary error={error}>
        <Heading variant="page/sm">
          <Heading.Eyebrow>
            <SkeletonBox className="my-1 h-4 w-36" loading={loading}>
              FX Batch Settlement
            </SkeletonBox>
          </Heading.Eyebrow>
          <Heading.Intro>
            <SkeletonBox className="my-1 h-4 w-58" loading={loading}>
              {t('customerFxBatchSettlementDetail.id', {
                id: data?.customerFxBatchSettlementByJobId.id,
              })}
            </SkeletonBox>
          </Heading.Intro>
        </Heading>
        <CustomerFxBatchSettlementCard
          loading={loading}
          settlement={data.customerFxBatchSettlementByJobId}
        />
        <div className="mt-6 space-y-4">
          {data.customerFxBatchSettlementByJobId.details.map((detail, ix) => (
            <CustomerFxBatchSettlementDetailCard
              key={detail.id}
              loading={loading}
              settlementDetail={detail}
              title={`Detail ${ix + 1}`}
            />
          ))}
        </div>
        <div className="mt-6 space-y-4">
          <TradesTable
            settlementId={data.customerFxBatchSettlementByJobId.id}
          />
        </div>
      </GraphQLErrorBoundary>
    </Content>
  )
}
